import { render, staticRenderFns } from "./AppReviewEvaluationTypeOptions.vue?vue&type=template&id=183b7834&scoped=true"
import script from "./AppReviewEvaluationTypeOptions.vue?vue&type=script&lang=js"
export * from "./AppReviewEvaluationTypeOptions.vue?vue&type=script&lang=js"
import style0 from "./AppReviewEvaluationTypeOptions.vue?vue&type=style&index=0&id=183b7834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183b7834",
  null
  
)

export default component.exports